(ns frontend.view.settings2.counterparty-diligence.sub
  (:require
   [clojure.edn :as edn]
   [common.schema.entities.counterparty-diligence.templates.notifications-registry
    :as notif-registry]
   [frontend.view.settings2.counterparty-diligence.model :as model]
   [re-frame.core :as rf]
   [ui.state.session.sub :as session-sub]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))

(rf/reg-sub
 ::saved-config
 :<- [::session-sub/tenant]
 (fn [tenant]
   (some-> tenant
           :tenant/counterparty-diligence-config
           (as-> raw
                 (cond
                   (map? raw)    raw
                   (string? raw) (try
                                   (edn/read-string raw)
                                   (catch :default _ {}))
                   :else         {})))))

(rf/reg-sub
 ::config
 :<- [::state]
 (fn [state]
   (get state model/config-key)))

(rf/reg-sub
 ::saving?
 :<- [::state]
 (fn [state]
   (boolean (get state model/saving-key))))

(rf/reg-sub
 ::notifications
 :<- [::session-sub/tenant]
 (fn [tenant]
   (notif-registry/notifications-for-tenant tenant)))

(rf/reg-sub
 ::recipients-input
 :<- [::state]
 (fn [state [_ notification-id]]
   (get-in state [:recipients-input notification-id])))

(rf/reg-sub
 ::invalid-emails
 :<- [::state]
 (fn [state [_ notification-id]]
   (get-in state [model/invalid-emails-key notification-id])))

(rf/reg-sub
 ::config-changed?
 :<- [::saved-config]
 :<- [::config]
 (fn [[saved current]]
   (not= (or saved {}) (or current {}))))

(rf/reg-sub
 ::preview-notification-id
 :<- [::state]
 (fn [state]
   (get state model/preview-notification-id-key)))

(rf/reg-sub
 ::preview-notification
 :<- [::notifications]
 :<- [::preview-notification-id]
 (fn [[notifications id]]
   (when id
     (->> notifications
          (filter #(= id (:id %)))
          first))))

(rf/reg-sub
 ::preview-variant-template-id
 :<- [::state]
 (fn [state]
   (get state model/preview-variant-template-id-key)))

(rf/reg-sub
 ::preview-variant
 :<- [::preview-notification]
 :<- [::preview-variant-template-id]
 (fn [[notification template-id]]
   (when notification
     (or (->> (:variants notification)
              (filter #(= template-id (:template-id %)))
              first)
         (first (:variants notification))))))
